import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { NavTopMain } from "../components/navTop";
import { HeaderBanner } from "../components/banners";
import PageFooter from "../components/footer";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const showConsole = false;

export default function Calendars() {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);

    //   const [calendar, setCalendar] = useState();
    const [calendarName, setCalendarName] = useState();
    const [calendarUrl, setCalendarUrl] = useState();

    const [navMenuItem, setNavMenuItem] = useState([]);

    async function fetchNavMenuItem() {
        await axios
            .get(`${apiUrl}nav/index.json`)
            .then((res) => {
                setNavMenuItem(res.data);
            })
            .catch((error) => {
                console.error(`nav axios err: ${error}`);
            });
    }

    const calendarData = {
        student: {
            name: "ปฏิทินกิจกรรมนักศึกษา คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม",
            url: "https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=Asia%2FBangkok&showCalendars=1&showPrint=0&src=dXJyamJsbjBwMjJxY2cwZGtsNzM2bXZzNDBAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&color=%230B8043",
        },
        meetingroom: {
            name: "ตารางการใช้งานห้องประชุม คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม",
            url: "https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=Asia%2FBangkok&showCalendars=1&showPrint=0&src=am5lZ3M0bWpxNDhrMXM2dmYyNzQyNjJubGtAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&src=dTduYmluNWw0MzAybnB2Z2NlZjk4NXEwM29AZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&src=MzBwYmRsN2xzMjIybG9wNGMya2k5NTVrNHNAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&color=%23A79B8E&color=%23009688&color=%23A79B8E",
        },
        lab211: {
            name: "ตารางการใช้ห้องปฏิบัติการคอมพิวเตอร์ คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม",
            url: "https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=Asia%2FBangkok&showCalendars=1&showPrint=0&src=Y2M1NmJmNzNjMTVmMWIwOTk5Yjk4OWQzYWZmYjc1OGY5NzUwMjljMmVkMWU4ODQ0OTdhZTYwZDkyYWJlNjU2NEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=Y283ZXViNmlnNWljM2VucDRrNXNzN3N2NjRAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&color=%237cb342&color=%237CB342",
        },
        lasercut: {
            name: "ตารางการใช้เครื่องยิงเลเซอร์ CO2 คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม",
            url: "https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=Asia%2FBangkok&showCalendars=1&showPrint=0&src=OTMzYmVmMDZkOTExYjJmOTFmYzRkYjY4NmNiY2IzMDY5ZDcxZjQ2NTg4YjgwZGE0NzBkNWVmNTg3MjhkYzljMEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23D50000",
        },
        meeting: {
            name: "กำหนดการประชุมภายในของ คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม",
            url: "https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=Asia%2FBangkok&showCalendars=1&showPrint=0&src=MGNlYzY4b2pnZnRoMTlnZ20wazZjaWZzcnNAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&src=dmw1a291ZWFhbWd0a2Zibm4zbjloY25uMnNAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&src=MmVtZ2ZhdmtsNHRlM29qMmNmdG4za281YXNAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&src=Zmw1MDE3azIzbzZidjVodjJ2b3RuaTJrNjRAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&color=%237986CB&color=%23F6BF26&color=%23C0CA33&color=%23F6BF26",
        },
    };

    const calendarCode = {
        meetingroom: [
            {
                name: "ห้องประชุม 201",
                code: "jnegs4mjq48k1s6vf274262nlk@group.calendar.google.com",
            },
            {
                name: "ห้องประชุม 202",
                code: "u7nbin5l4302npvgcef985q03o@group.calendar.google.com",
            },
            {
                name: "ห้องประชุมใหญ่",
                code: "30pbdl7ls222lop4c2ki955k4s@group.calendar.google.com",
            },
        ],
        student: [
            {
                name: "กิจกรรมนักศึกษา",
                code: "urrjbln0p22qcg0dkl736mvs40@group.calendar.google.com",
            },
        ],
        lab211: [
            {
                name: "ห้องปฏิบัติการคอมพิวเตอร์ 211",
                code: "co7eub6ig5ic3enp4k5ss7sv64@group.calendar.google.com",
            },
        ],
        lasercut: [
            {
                name: "เครื่องยิงเลเซอร์ ห้องปฏิบัติการวิชาชีพ",
                code: "933bef06d911b2f91fc4db686cbcb3069d71f46588b80da470d5ef58728dc9c0@group.calendar.google.com",
            },
        ],
        meeting: [
            {
                name: "ประชุมบริการวิชาการ",
                code: "0cec68ojgfth19ggm0k6cifsrs@group.calendar.google.com",
            },
            {
                name: "ประชุมกรรมการวิจัย",
                code: "2emgfavkl4te3oj2cftn3ko5as@group.calendar.google.com",
            },
            {
                name: "ประชุมกรรมการวิชาการ",
                code: "fl5017k23o6bv5hv2votni2k64@group.calendar.google.com",
            },
            {
                name: "ประชุมกรรมการคณะฯ",
                code: "vl5koueaamgtkfbnn3n9hcnn2s@group.calendar.google.com",
            },
        ],
    };
    useEffect(() => {
        switch (id) {
            case "student":
                setCalendarName(calendarData[id].name);
                setCalendarUrl(calendarData[id].url);
                break;
            case "meetingroom":
                setCalendarName(calendarData[id].name);
                setCalendarUrl(calendarData[id].url);
                break;
            case "lab211":
                setCalendarName(calendarData[id].name);
                setCalendarUrl(calendarData[id].url);
                break;
            case "lasercut":
                setCalendarName(calendarData[id].name);
                setCalendarUrl(calendarData[id].url);
                break;
            case "meeting":
                setCalendarName(calendarData[id].name);
                setCalendarUrl(calendarData[id].url);
                break;
            default:
                console.error("Error: Missing Parameters.");
        }
        showConsole && console.log("id:", id);
        showConsole && console.log("calendarCode:", calendarCode);

        // const genCalendar = () => {
        //   return (
        //     <>
        //       <div id="contentHolder" style={{ marginBottom: "40px" }}>
        //         <HeaderBanner />
        //         <div
        //           data-aos="fade-down"
        //           data-aos-duration="800"
        //           style={{ zIndex: "9999" }}
        //         >
        //           <NavTop />
        //         </div>
        //         {isLoading ? (
        //           <div>IS LOADING 2...</div>
        //         ) : (
        //           <div style={{ zIndex: "1" }}>
        //             {calendar ? (
        //               // <NewsContent newsData={newsInfo} />
        //               <></>
        //             ) : (
        //               <div
        //                 style={{
        //                   margin: "180px 10px",
        //                   textAlign: "center",
        //                   fontSize: "2.5rem",
        //                   color: "#666666",
        //                   textTransform: "uppercase",
        //                 }}
        //               >
        //                 this page is no content.
        //               </div>
        //             )}
        //           </div>
        //         )}
        //       </div>
        //       <PageFooter />
        //     </>
        //   );
        // };

        // setCalendar(genCalendar);
        setIsLoading(false);
        showConsole && console.log("loading:", isLoading);

        fetchNavMenuItem();

        AOS.init();
        // eslint-disable-next-line
    }, []);

    // return calendar;
    return (
        <>
            <div id="contentHolder">
                <HeaderBanner />
                {navMenuItem && <NavTopMain navMenuItem={navMenuItem} />}
                <section id="mainContent" style={{ marginTop: "30px" }}>
                    {/* {console.log("page params: " , page)} */}
                    {!isLoading && (
                        <>
                            <div
                                style={{
                                    marginBottom: "10px",
                                    fontSize: "1.2rem",
                                    textAlign: "center",
                                }}
                            >
                                {calendarName}
                            </div>
                            <iframe
                                title={calendarName}
                                width="100%"
                                height="800"
                                src={calendarUrl}
                                frameBorder="0"
                                allowFullScreen
                            ></iframe>
                            <div className="mt-3">
                                <h5>ดาวน์โหลดปฏิทิน</h5>
                                <ol>
                                    {calendarCode[id] &&
                                        calendarCode[id].map((val, index) => {
                                            return (
                                                <li key={index}>
                                                    <a
                                                        href={`https://calendar.google.com/calendar/ical/${val.code}/public/basic.ics`}
                                                    >
                                                        {val.name}
                                                    </a>
                                                </li>
                                            );
                                        })}
                                </ol>
                            </div>
                        </>
                    )}
                </section>
            </div>
            {navMenuItem && <PageFooter navMenuItem={navMenuItem} />}
        </>
    );
}
